import { useMemo } from 'react';
import { useDebounce } from 'usehooks-ts';
import api from 'lib/trpcClient';
import { InvestorValidationLabels } from 'further-ui/labels';

type Props = {
  registeredName: string | undefined;
  firmId: string | undefined;
  ignoreInvestorId?: string;
};

export const useDuplicateLegalEntityInvestorWarning = ({
  registeredName,
  firmId,
  ignoreInvestorId,
}: Props) => {
  const debouncedInvestor = useDebounce(
    {
      registeredName: registeredName ?? '',
    },
    300,
  );

  const enabled = !!debouncedInvestor.registeredName && !!firmId;

  const { data } = api.investor.checkLegalEntityInvestorUnique.useQuery(
    {
      registeredName: debouncedInvestor.registeredName,
      firmId: firmId ?? '',
      ignoreInvestorId,
    },
    {
      enabled,
    },
  );

  return useMemo(
    () => ({
      hasWarning: enabled && data === false,
      message: InvestorValidationLabels.LegalEntityAccountNotUnique,
    }),
    [data, enabled],
  );
};
